import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge42 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='アコーディア・ゴルフグループのゴルフ会員権とは？' fontWeight={700} />
                <p>
                    アコーディア・ゴルフは、国内最大級の運営コース数を誇るゴルフ場運営会社です。
                    <br />
                    2025年4月時点で全国172コースを運営しており、社員数は2025年3月31日時点で9,962名となっています。
                    <br />
                    コース数が多いぶん、エリアや価格帯の異なるさまざまなコースの会員権を選べることが大きな特徴です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='アコーディア・ゴルフグループの会員権の選び方' fontWeight={700} />
                <Heading3 title='コース数が多いからこそエリアで選ぶ' />
                <p>
                    全国172コースという規模のため、まずはご自身が頻繁にプレーしたいエリアを絞り込むことが会員権選びの第一歩になります。
                    <br />
                    ※系列間の優待制度や相互利用プログラムの詳細については、コースごとに異なる場合があるため、購入前に必ず公式サイトまたはクラブへ直接ご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='アコーディア・ゴルフグループのおすすめのゴルフ場は？' fontWeight={700} />
                <p>
                    アコーディア・ゴルフグループのゴルフ場一覧は
                    <a href='https://juchi.jp/courses?series_id=2' className={s.link}>
                        こちら
                    </a>
                    よりご確認ください。
                </p>
                <Heading3 title='アコーディア・ゴルフグループのコースをご紹介' />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/95'>成田ゴルフ倶楽部</a>
                </div>
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/6'>東京相武カントリークラブ</a>
                </div>
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/67'>グレンオークスカントリークラブ</a>
                </div>
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/100'>ニュー南総ゴルフ倶楽部</a>
                </div>
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/656'>ザ・サザンリンクスゴルフクラブ</a>
                </div>
                <p>
                    コースごとの特徴やコースレイアウトの詳細については、各コースページをご確認いただくか、弊社までお気軽にお問合せください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    アコーディア・ゴルフグループは運営コース数が多いため、選択肢の幅広さが魅力です。
                    <br />
                    <br />
                    ご希望のエリアや予算に合わせたコース選びについては、お気軽に弊社にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge42;
